/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type PCCProgram = typeof PCCProgram[keyof typeof PCCProgram];


export const PCCProgram = {
  CCM: 'CCM',
  RTM: 'RTM',
  Tempo: 'Tempo',
} as const;
